import React, { useRef, useState, useEffect } from "react";
import { Col, Row, Typography, Button, Form, Input } from "antd";
import nibbleslogo from "../../asset/nibbleslogo.jpg";
import "./onboarding.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAuthReducer } from "../../redux/Reducer/authReducer";
import { getEnterOtp, getResendOtp } from "../../redux/Actions";

const { Title, Text } = Typography;

const maskEmail = (email) => {
  if (!email || !email.includes("@")) return "";
  const [local, domain] = email.split("@");
  const visible = local.slice(0, 2);
  return `${visible}${"*".repeat(Math.max(local.length - 2, 1))}@${domain}`;
};

const onFinish = () => {};
const onFinishFailed = () => {};

export default function ForgetPasswordEnterOtp() {
  const navigate = useNavigate();
  const { otpcode, verifyingotp } = useSelector(getAuthReducer);
  const dispatch = useDispatch();
  const [otpCodeDetails, setOtpCodeDetails] = useState({
    code: "",
    email: ""
  });
  const initialTimer = 600; // 10 minutes in seconds
  const [timer, setTimer] = useState(initialTimer);
  const [counting, setCounting] = useState(true)

  const inputRefs = useRef([]);

  const [form] = Form.useForm();
  const formLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  const forgotpasswordemail = JSON.parse(localStorage.getItem("forgotpasswordemail"))

  // Function to move focus to the next input
  const handleInputChange = (e, index) => {
    const value = e.target.value;
    const updatedOtp = otpCodeDetails.code.substr(0, index) + value + otpCodeDetails.code.substr(index + 1);
    setOtpCodeDetails({ ...otpCodeDetails, code: updatedOtp, email: forgotpasswordemail });

    // Move focus to the next input field
    if (value && /^\d*$/.test(value) && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    // Move focus to the previous input field on backspace
    if (e.key === "Backspace" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleInputs = (e, index) => {
    if (
      !/^\d*$/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "ArrowRight"
    ) {
      e.preventDefault();
    } else {
      handleKeyDown(e, index);
    }
  };

  const verityOTP = () => {
    // debugger
    dispatch(getEnterOtp(otpCodeDetails))
  };

  const handleResendOTP = () => {
    const email = forgotpasswordemail
    dispatch(getResendOtp({email: email}))
    setTimer(10); // Reset timer to 10 minutes
    setCounting(true); // Start countdown
  };

  useEffect(() => {
    let interval;
    if (timer > 0 && counting) {
      interval = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setCounting(false);
    }
    return () => clearInterval(interval);
  }, [timer, counting]);

  useEffect(() => {
    if (!counting && timer === 0) {
      // Timer finished, enable resend OTP button
      setTimer(initialTimer); // Reset timer for the next OTP
    }
  }, [counting, timer, initialTimer]);

  useEffect(() => {
    if (otpcode?.status === true) {
      // debugger
      navigate("/changepassword")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otpcode])

  return (
    <>
      <Row>
        <Col
          xs={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 12 }}
          className="getstartedbackground"
        ></Col>

        <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} className="getstartefirstrowlogo">
          <Row className="getstartedrowlogo">
            <Col span={24} className="getstartedcollogo">
              <img alt="nibbleslogo" src={nibbleslogo} />
            </Col>
          </Row>

          <Row>
            <Col span={24} className="getstartedcolpadotp">
              <Title
                className="typography getstartedtext"
                style={{ marginBottom: "0px" }}
                level={1}
              >
                Enter Code
              </Title>
              <Text className="joinbakery typography">
                We sent an OTP code to {maskEmail(forgotpasswordemail)}. Kindly fill
                in the code below.
              </Text>
            </Col>

            <Col span={24} className="getstartedcolpadotp">
              <Form
                {...formLayout}
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                size={"large"}
                className="typography"
              >
                <Col
                  xs={{ span: 24 }}
                  className="otpLayoutinputs"
                  style={{ marginBottom: "2em" }}
                >
                  {Array.from({ length: 6 }, (_, index) => (
                    <Input
                      key={index}
                      type=""
                      ref={(el) => (inputRefs.current[index] = el)}
                      value={otpCodeDetails.code[index]}
                      maxLength={1}
                      onChange={(e) => handleInputChange(e, index)}
                      onKeyDown={(e) => handleInputs(e, index)}
                      className="otpinputs"
                    />
                  ))}
                </Col>

                <Col xs={{ span: 24 }}>
                  <Button
                    className="signupbutton typography"
                    htmlType="submit"
                    block
                    disabled={otpCodeDetails.code.length !== 6 || verifyingotp}
                    onClick={verityOTP}
                  >
                    {verifyingotp ? 'Loading...' : 'Verify Email'}
                  </Button>
                </Col>

                <Col xs={{ span: 24 }}>
                  <Button
                    className="resendotpbutton typography"
                    block
                    onClick={handleResendOTP}
                    disabled={counting}
                  >
                    {counting ? `Resend OTP in ${Math.floor(timer / 60)}:${timer % 60 < 10 ? `0${timer % 60}` : timer % 60}` : 'Resend OTP'}
                  </Button>
                </Col>

                <Col span={24} className="getstartedcolpadterms">
                  <Text className="typography text-center" style={{ display: "block" }}>
                    Didn't get a code? Check spam or{" "}
                    <Link
                      to={"/signin"}
                      style={{ color: "#998C16", textDecoration: "underline" }}
                      className="signinlink"
                    >
                      log in
                    </Link>
                  </Text>
                </Col>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
